import { Dots } from "../LoadingAnimations/LoadingAnimations";
import { getDuration } from "../../Interceptor/csrftoken";
import { useTranslation } from "react-i18next";

const Truck34Hour = ({ truckState }) => {
  const { t } = useTranslation();

  const calculateHoursDifference = (timestampString) => {
    const timestamp = new Date(timestampString);
    const currentTime = new Date();

    // Calculate the difference in milliseconds
    const differenceInMilliseconds = currentTime - timestamp;

    // Convert milliseconds to hours
    const differenceInHours = differenceInMilliseconds / (1000 * 60 * 60);
    return differenceInHours;
  };

  return (
    <div className="graphics-card-but-small">
      <h4 className="global-h4 gray">
        {t("graphics-cont.recent-activity.trailer-34hr")}
      </h4>
      {truckState.error && <p className="error">{truckState.error}</p>}
      <div className="recent-activity">
        {truckState.isFetchingData ? (
          <Dots />
        ) : (
          truckState.data
            .filter(
              (item) => calculateHoursDifference(item.truck.check_in_dt) >= 34
            ).sort((a, b) => a > b ? -1 : 1)
            .map((item, index) => (
              <div key={index} className="activity-item">
                <span className="global-h5 gray">
                  {item.truck.carrier_name}-{item.truck.truck_number}
                </span>
                <span style={{ color: "#FB6060" }}>
                  {getDuration(item.truck.check_in_dt)}
                </span>
              </div>
            ))
        )}
      </div>
    </div>
  );
};

export default Truck34Hour;
